/* eslint-disable no-useless-constructor */
import React, { Component } from "react";
import { Container } from "reactstrap";

import AnimatedCursor from "react-animated-cursor";
import { Box } from "@chakra-ui/react";

export class AnimateCursor extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Box zIndex={999}>
        <AnimatedCursor
          innerSize={15}
          outerSize={30}
          color={this.props.CursorColor}
          outerAlpha={0.2}
          innerScale={0.7}
          outerScale={3}
          clickables={[
            "a",
            'input[type="text"]',
            'input[type="email"]',
            'input[type="number"]',
            'input[type="submit"]',
            'input[type="image"]',
            "label[for]",
            "select",
            "textarea",
            "button",
            ".link",
          ]}
        />

        <Container>{this.props.children}</Container>
      </Box>
    );
  }
}
